import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'

// Import des slices
import userReducer from './slices/userSlice'
import productCertificationReducer from './slices/productCertificationSlice'
// ... autres imports à venir

const rootReducer = combineReducers({
  user: userReducer,
  productCertification: productCertificationReducer,
  // ... autres reducers
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'] // Seul l'user a besoin de persistance
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export const persistor = persistStore(store)